module.exports = __webpack_public_path__ + "static/media/person-dolly-empty.8d91215e.svg";